export default __webpack_public_path__ + "static/media/matchtrader_nameless.a19be58c.webp";